( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {
        // --------------------------------------------------
        // DECLARE VARS
        // --------------------------------------------------
        // Data
        var isMobile = null;

        // Elems.
        var bodyElem = $( 'body' );
        var headerNavLinks = $( '.js--nav-links > li:not(.js--header-sub-nav), .js--header-sub-nav li' );
        var drawerNavElem = $( '.js--drawer-nav' );
        var navToggleElems = $( '.js--nav-toggle, .js--nav-close' );
        var searchToggleElem = $( '.js--search-toggle' );
        var drawerSearchElem = $( '.js--drawer-search' );
        var drawerSearchField = drawerSearchElem.find( '.js--search-field' );
        var drawerSearchSubmit = drawerSearchElem.find( '.js--search-submit' );
        var focusableElems = ( drawerNavElem && drawerNavElem.length ) ? drawerNavElem.find( '[tabindex]' ) : null;
        var firstFocusableElem = ( focusableElems && focusableElems.length ) ? focusableElems.first() : null;
        var lastFocusableElem = ( focusableElems && focusableElems.length ) ? focusableElems.last() : null;

        // --------------------------------------------------
        // DEFINE FUNCTIONS
        // --------------------------------------------------
        function toggleDrawerNav() {
            if ( bodyElem && drawerNavElem ) {
                bodyElem.toggleClass( 'drawer-nav-active' );

                // Set focus on 'nav open' or 'nav close' elem.
                // NOTE: If/else is reversed from earlier version, because toggling of 'is-active' on drawerNavElem is now inside of conditional statement, not before it.

                if ( drawerNavElem.hasClass( 'is-active' ) ) {

                    // CLOSE drawer nav:

                    $( '.js--nav-toggle' ).focus();
                    utilsRef.windowUnfreeze();
                    drawerNavElem.removeClass( 'is-active' );

                    // NOTE: setTimeout interval is linked to CSS transition duration value.
                    setTimeout( function() {
                        drawerNavElem.hide();
                    }, 150 );

                    // Disable focus on child elems.
                    drawerNavElem.find( '[tabindex]' ).attr( 'tabindex', -1 );

                } else {

                    // OPEN drawer nav:

                    drawerNavElem.show( 0, function() {
                        drawerNavElem.addClass( 'is-active' );
                    } );
                    $( '.js--nav-close' ).focus();
                    utilsRef.windowFreeze();

                    // Enable focus on child elems.
                    drawerNavElem.find( '[tabindex]' ).attr( 'tabindex', 0 );

                }
            }
        }

        function toggleSearch() {
            // Toggle classes on search toggle CTA.
            if ( searchToggleElem ) {
                searchToggleElem.toggleClass( 'is-active' );
            }

            if ( drawerSearchElem ) {
                drawerSearchElem.toggleClass( 'is-active' );

                if ( drawerSearchElem.hasClass( 'is-active' ) ) {
                    drawerSearchElem.find( 'input' ).attr( 'tabindex', '' );
                    drawerSearchElem.find( '.js--search-field' ).focus();
                } else {
                    drawerSearchElem.find( 'input' ).attr( 'tabindex', '-1' );
                    searchToggleElem.focus();
                }
            }
        }

        /**
         * Remove hash from URL string. If there is none, return URL string untouched
         */
        function cleanHash( urlString ) {
            if ( urlString.indexOf( '#' ) >= 0 ) {
                // Pattern from https://stackoverflow.com/a/7124976
                return urlString.match( /.+?(?=#)/g )[ 0 ];
            } else {
                return urlString;
            }
        }

        /**
         * Update css classes of menu links when the page changes. Show a sub-nav if necessary.
         */
        function updateMenusOnPageChange( currentUrl ) {

            // Show sub-nav, if one exists
            headerNavLinks.removeClass( 'is-current' );
            headerNavLinks.find( '> a' ).each( function() {
                if( currentUrl.indexOf( this.href ) >= 0 ) {
                    $( this ).parent( 'li' ).addClass( 'is-current' );
                }
            } );

            // Make links to current page, and their parent links, bold
            headerNavLinks.find( '> a' ).removeClass( 'current-menu-item' ).removeClass( 'current-page-ancestor' );

            headerNavLinks.find( '> a' ).each( function() {
                if ( cleanHash( currentUrl ).indexOf( $( this ).attr( 'href' ) ) >= 0 ) {
                    // Find current page links
                    if ( cleanHash( currentUrl ).length === $( this ).attr( 'href' ).length ) {
                        $( this ).addClass( 'current-menu-item' );
                    // Find parent page links
                    } else if ( cleanHash( currentUrl ).length > $( this ).attr( 'href' ).length ) {
                        $( this ).addClass( 'current-page-ancestor' );
                    }
                }
            } );
        }

        /**
         * Sub-navs use absolute positioning. If one is visible, add margin-bottom to the header to keep spacing correct.
         */
        function addSubNavSpacingToHeader() {
          if ( $( '.js--header-sub-nav' ).is( ':visible' ) ) {
              var subNavHeight = $( '.js--header-sub-nav' ).height();
              $( '.js--header' ).css( 'margin-bottom', subNavHeight + 'px' );
          } else {
              $( '.js--header' ).css( 'margin-bottom', '0' );
          }
        }

        function init() {

            // EVENTS
            // Handle 'click' events on 'nav toggle'
            navToggleElems.on( 'click', toggleDrawerNav );

            // Handle 'click' events on 'search toggle'.
            searchToggleElem.on( 'click', function( e ) {
                e.stopPropagation(); // NOTE: Prevent listeners on ancestor elems. from reverting 'toggle'.
                toggleSearch();
            } );

            // // Handle 'keydown' events on focusable elems. within 'drawer nav'.
            drawerNavElem.find( '[tabindex]' ).keydown( function( e ) {
                if ( firstFocusableElem.length && this === firstFocusableElem.get( 0 ) ) {
                    if ( e.keyCode === 9 && e.shiftKey ) {
                        toggleDrawerNav();
                    }
                }

                if ( lastFocusableElem.length && this === lastFocusableElem.get( 0 ) ) {
                    if ( e.keyCode === 9 && !e.shiftKey ) {
                        toggleDrawerNav();
                    }
                }
            } );

            // Handle 'keydown' events on 'search submit'.
            drawerSearchSubmit.keydown( function( e ) {
                // Close the 'search drawer' if the current key is TAB and SHIFT *IS NOT* depressed.
                if ( e.keyCode === 9 && !e.shiftKey ) {
                    toggleSearch();
                }
            } );

            // Handle 'keydown' events on 'search field'.
            drawerSearchField.keydown( function( e ) {
                // Close the 'search drawer' if the current key is TAB and SHIFT *IS* depressed.
                if ( e.keyCode === 9 && e.shiftKey ) {
                    toggleSearch();
                }
            } );

            // Close search bar if it is open, and user clicks outside of it.
            document.addEventListener( 'click', function( e ) {
                if ( drawerSearchElem.hasClass( 'is-active' ) ) {
                    if ( !$( e.target ).parents( '.js--drawer-search' ).length && !$( e.target ).parents( '.js--search-toggle' ).length ) {
                        toggleSearch();
                    }
                }
            } );

            updateMenusOnPageChange( window.location.href );

            addSubNavSpacingToHeader();

        }

        /**
         * Wrapper around *any* logic which should be triggered on window resize.
         */
        function resizeEventHandler( e ) {
            var winWidth = parseInt( window.outerWidth );

            // Close 'drawer nav' when mobile/tablet threshold is crossed.
            if ( drawerNavElem.hasClass( 'is-active' ) && isMobile && winWidth >= 992 ) {
                toggleDrawerNav();
            }

            // Update.
            isMobile = ( winWidth < 992 );
        }

        // --------------------------------------------------
        // REGISTER EVENTS
        // --------------------------------------------------
        $( window ).on( 'resize', resizeEventHandler );

        // --------------------------------------------------
        // INIT
        // --------------------------------------------------
        init();

        // Make sure drawer nav is closed when new page is loaded
        if ( typeof Barba !== 'undefined' && typeof Barba.Dispatcher === 'object' ) {
            Barba.Dispatcher.on( 'newPageReady', function() {

                // Close drawer nav
                if ( drawerNavElem.hasClass( 'is-active' ) ) {
                    toggleDrawerNav();
                }

                // Close search bar
                searchToggleElem.removeClass( 'is-active' );
                drawerSearchElem.removeClass( 'is-active' );

                updateMenusOnPageChange( window.location.href );

                addSubNavSpacingToHeader();

            } );
        }

    } );
} )( window, document, jQuery );
